import * as React from 'react';

import { Navigate, useLocation } from 'react-router-dom';

import { ROUTES } from '../constants';
import { useAuth } from '../hooks/useAuth';

export default function PrivateRoute({ children }: { children: any }): React.JSX.Element {
  const { authed } = useAuth();
  const location = useLocation();
  const [pending, setPending] = React.useState(true);

  React.useEffect(() => {
    const timer = setTimeout(() => setPending(false), 300);
    return () => clearTimeout(timer);
  }, []);

  // Hold for 300ms to allow BroadcastChannel token relay to arrive before deciding to redirect
  if (pending && !authed) return <></>;

  return authed ? (
    children
  ) : (
    <Navigate to={ROUTES.LoginPage} replace state={{ path: location.pathname }} />
  );
}
